
/* injects from baggage-loader */

'use strict';

import IssuerOnboardingDetailsController from './issuer-onboarding.details.controller';
import IssuerOnboardingDetailsTemplate from './issuer-onboarding.details.html';

export default class IssuerOnboardingDetailsComponent {
		constructor() {
				this.templateUrl = IssuerOnboardingDetailsTemplate;
				this.controller = IssuerOnboardingDetailsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					onboarding: '<'
				};
		}
}
